var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bill-status-container"},[_c('span',{class:_vm.statusClass},[_vm._v(_vm._s(_vm.billStatus[_vm.status]))])])}
var staticRenderFns = []

export { render, staticRenderFns }